import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { contentCountsRequest } from '../../app/actions/spaces/ContentCountsActions';
import { selectContentCounts, selectContentCountsUpToDate } from '../../app/selectors/ContentCountsSelector';
import { siteUrlsSelector } from '../../app/selectors/SiteUrlsSelectors';
import { selectSpaceInfo } from '../../app/selectors/SpaceInfoSelectors';
import { AppState } from '../../app/state/AppState';
import { MapDispatchToProps, MapStateToProps } from '../../app/utils/ConnectUtils';
import { selectCatalogingOnSiteEnabled } from '../../catalog/selectors/CatalogSelectors';
import { DataRoleSpace, DataRoleSpaceDispatchProps, DataRoleSpaceStateProps } from './DataRoleSpace';

const mapStateToProps: MapStateToProps<DataRoleSpaceStateProps> = (state: AppState) => ({
  spaceInfo: selectSpaceInfo(state),
  urls: siteUrlsSelector(state),
  catalogingOnSiteEnabled: selectCatalogingOnSiteEnabled(state),
  contentCounts: selectContentCounts<'dataRole'>(state, 'dataRole'),
  contentCountsUpToDate: selectContentCountsUpToDate(state),
});

const mapDispatchToProps: MapDispatchToProps<DataRoleSpaceDispatchProps> =
  (dispatch) => bindActionCreators({
    fetchUpdatedContentCounts: contentCountsRequest,
  },
  dispatch);

export const ConnectedDataRoleSpace = connect(mapStateToProps, mapDispatchToProps)(DataRoleSpace);
